import { getVariantPath } from '@uswitch/ev-utils/get-variant-path';
import { useEntities, useEntity, useMeta } from '@uswitch/ev-utils/context/selectors';
import { contentTypeId } from '@uswitch/ev-utils/contentful';
import { Type } from '@uswitch/spark';
import { List as SparkList, ListItem as SparkListItem } from '@uswitch/spark.list';
import { DynamicSparkIcon } from '../../elements/spark-icons/dynamic-spark-icon';
import { Link } from '@uswitch/ev-core/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var stylePath = function stylePath(field, variant) {
  return getVariantPath({
    atomicType: 'modules',
    componentId: 'subNavigation',
    variantName: variant,
    field: field
  });
};

var SubNavigationBlocks = function SubNavigationBlocks(_ref) {
  var _ref$lists = _ref.lists,
      lists = _ref$lists === void 0 ? [] : _ref$lists;
  var linkListEntities = useEntities(lists).map(function (_ref2) {
    var links = _ref2.links,
        subtitle = _ref2.subtitle;
    return {
      links: links,
      subtitle: subtitle
    };
  });
  var listLength = linkListEntities.length;
  return _jsx("div", {
    sx: {
      width: '100%',
      display: 'flex',
      flexDirection: ['column', 'row'],
      flexWrap: 'wrap',
      justifyContent: 'space-between'
    },
    children: linkListEntities.map(function (listEntity, idx) {
      return _jsx(SubNavigationList, {
        listEntity: listEntity,
        last: idx + 1 === listLength
      }, idx);
    }, this)
  });
};

var SubNavigationList = function SubNavigationList(_ref3) {
  var _ref3$listEntity = _ref3.listEntity,
      links = _ref3$listEntity.links,
      subtitle = _ref3$listEntity.subtitle,
      last = _ref3.last;
  var linkEntities = useEntities(links);
  var parentListIncludesIcon = linkEntities.some(function (_ref4) {
    var icon = _ref4.icon;
    return icon;
  });
  return _jsxs("div", {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: '100%',
      marginBottom: last ? 0 : ['0', 'xl']
    },
    children: [subtitle ? _jsx(Type.H5, {
      sx: {
        marginBottom: ['md', 'md', 'lg']
      },
      children: subtitle
    }) : null, _jsx(SparkList, {
      sx: {
        display: 'grid',
        gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr 1fr'],
        gridGap: '16px'
      },
      children: linkEntities.map(function (link, idx) {
        return _jsx(SubNavigationLink, {
          link: link,
          parentListIncludesIcon: parentListIncludesIcon
        }, idx);
      }, this)
    })]
  });
}; // Links


var SubNavigationLink = function SubNavigationLink(_ref5) {
  var link = _ref5.link,
      parentListIncludesIcon = _ref5.parentListIncludesIcon;
  var contentType = contentTypeId(link);
  var icon = link.icon;
  var isUrl = contentType === 'url';
  return _jsx("div", {
    sx: {
      backgroundColor: 'grey-0'
    },
    children: isUrl ? _jsx(UrlLinkCard, {
      link: link,
      icon: icon,
      parentListIncludesIcon: parentListIncludesIcon
    }) : _jsx(LinkListLinkCard, {
      link: link,
      icon: icon,
      parentListIncludesIcon: parentListIncludesIcon
    })
  });
};

var UrlLinkCard = function UrlLinkCard(_ref6) {
  var link = _ref6.link,
      icon = _ref6.icon,
      parentListIncludesIcon = _ref6.parentListIncludesIcon;
  var linkText = link.linkText,
      pages = link.variants,
      url = link.url;
  var baseUrl = useMeta(['authorSchema', 'organizationUrl']).slice(0, -1);
  var pageEntities = useEntities(pages);
  var filteredPages = pageEntities.filter(function (variant) {
    return contentTypeId(variant) === 'richPage' || contentTypeId(variant) === 'modularPage';
  });
  var linkHref = baseUrl + url;
  var title = linkText || filteredPages[0].title;
  return _jsx(LinkItem, {
    linkHref: linkHref,
    title: title,
    icon: icon,
    parentListIncludesIcon: parentListIncludesIcon
  });
};

var LinkListLinkCard = function LinkListLinkCard(_ref7) {
  var link = _ref7.link,
      icon = _ref7.icon,
      parentListIncludesIcon = _ref7.parentListIncludesIcon;
  var title = link.title,
      url = link.url,
      urlRef = link.urlRef;
  var baseUrl = useMeta(['authorSchema', 'organizationUrl']).slice(0, -1);
  var urlRefEntity = useEntity(urlRef);
  var linkHref = urlRefEntity !== null && urlRefEntity !== void 0 && urlRefEntity.url ? baseUrl + urlRefEntity.url : url;
  return _jsx(LinkItem, {
    linkHref: linkHref,
    title: title,
    icon: icon,
    parentListIncludesIcon: parentListIncludesIcon
  });
};

var LinkItem = function LinkItem(_ref8) {
  var linkHref = _ref8.linkHref,
      title = _ref8.title,
      icon = _ref8.icon,
      parentListIncludesIcon = _ref8.parentListIncludesIcon;
  return _jsxs(Link, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px',
      textDecoration: 'none',
      borderBottom: 'none',
      svg: {
        fill: 'currentColor'
      },
      marginBottom: 0
    },
    href: linkHref,
    children: [_jsx(SparkListItem, {
      icon: icon && _jsx(DynamicSparkIcon, {
        glyph: icon,
        sx: {
          width: '20px',
          strokeWidth: 0.75,
          marginLeft: '10px',
          color: 'grey-100',
          variant: stylePath('linkCard.icon', 'blocks')
        }
      }),
      sx: {
        marginLeft: !icon && parentListIncludesIcon ? '50px' : icon ? '0' : '10px',
        padding: '0 20% 0 0',
        textDecoration: 'none',
        alignItems: 'center',
        flex: '1'
      },
      as: "div",
      children: _jsx(Type.H6, {
        as: "span",
        sx: {
          wordBreak: 'break-word',
          variant: stylePath('linkCard.text', 'blocks')
        },
        children: title
      })
    }), _jsx("div", {
      sx: {
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'flex-start',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'grey',
        boxSizing: 'border-box',
        padding: ['12px', '16px'],
        maxHeight: '50px',
        variant: stylePath('buttonContainer', 'blocks')
      },
      children: _jsx(DynamicSparkIcon, {
        glyph: 'arrow',
        direction: "right",
        sx: {
          width: '13.3px',
          height: '13.3px',
          color: 'grey-100',
          variant: stylePath('linkCard.arrow', 'blocks')
        }
      })
    })]
  });
};

export default SubNavigationBlocks;
//# sourceMappingURL=sub-navigation-blocks.js.map